import type { ApiMagentoPurchaseType } from "@jti/magento-types";

import type { ConsumablesMatrixData } from "@product-details/containers";

import { getMatrixItemsByPurchaseType } from "../getMatrixItemsByPurchaseType/getMatrixItemsByPurchaseType";

export const getMatrixItemByPurchaseTypeAndPackagingFormat = (
  consumables: ConsumablesMatrixData,
  purchaseType: ApiMagentoPurchaseType,
  currentPackagingFormatId: string
) =>
  getMatrixItemsByPurchaseType(consumables, purchaseType).find(
    (item) => item.packagingFormatId === currentPackagingFormatId
  );
